import styled from 'styled-components';
import { screenSmMin, screenLgMin } from '@spotify-internal/encore-foundation';
import { Type } from '@spotify-internal/encore-web';
export const Wrapper = styled.header `
  text-align: ${({ textAlign }) => textAlign};

  line-height: 1.5;

  @media (min-width: ${screenSmMin}) {
    width: var(--container-small-width, auto);
  }

  ${({ disableEndMargin }) => !disableEndMargin &&
    `
    margin-bottom: 30px;

    @media (min-width: ${screenSmMin}) {
      margin-bottom: 72px;
    }
  `};
`;
export const Title = styled(Type.h1) `
  margin-block-start: 0;
  margin-block-end: 0;
  font-size: var(--headline-font-size, 32px);
  line-height: var(--headline-line-height, 1.3);
  letter-spacing: -0.015em;
  font-weight: 900;
  padding: 0;

  @media (min-width: ${screenSmMin}) {
    font-size: var(--headline-font-size, 48px);
  }
`;
export const Supheader = styled(Type.h3) `
  margin-bottom: 20px;
`;
export const Subheader = styled(Type.h2) `
  font-weight: normal;
  font-size: var(--subheadline-font-size, 13px);
  line-height: var(--subheadline-line-height, 20px);
  margin-top: 10px;
  padding: 0;

  @media (min-width: ${screenSmMin}) {
    font-size: var(--subheadline-font-size, 20px);
    width: var(--subheadline-small-width, inherit);
    margin-top: 15px;
  }

  @media (min-width: ${screenLgMin}) {
    width: var(--subheadline-large-width, inherit);
  }
`;
//# sourceMappingURL=components.js.map